export default "__VITE_ASSET__D5GhC2f6__"